'use client';

import Script from 'next/script';

// Meta Pixel — only renders when NEXT_PUBLIC_META_PIXEL_ID is set (production). Gives Meta Ads a
// real conversion signal (CompleteRegistration) instead of "landing page views", so campaigns can
// be optimised and judged on sign-ups. Fire events via trackMetaEvent() below.
const PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

declare global {
  interface Window { fbq?: (...args: any[]) => void }
}

export function trackMetaEvent(name: 'CompleteRegistration' | 'Lead' | 'Subscribe' | 'InitiateCheckout' | 'Purchase' | 'ViewContent', params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  try { window.fbq('track', name, params ?? {}); } catch { /* ignore */ }
}

export default function MetaPixel() {
  if (!PIXEL_ID) return null;
  return (
    <>
      <Script id="meta-pixel" strategy="afterInteractive">{`
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init','${PIXEL_ID}');fbq('track','PageView');`}</Script>
      <noscript><img height="1" width="1" style={{ display: 'none' }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} /></noscript>
    </>
  );
}
